import { useQuery } from "@tanstack/react-query";
import api, { normalizeApiPlatformCollection } from "@/lib/api";
import { queryKeys } from "@/lib/api/queryKeys";
import { API_ENDPOINTS } from "@/lib/config/constants";

export function useTypeDemandes() {
  return useQuery({
    queryKey: queryKeys.collections.typeDemandes(),
    queryFn: async () => {
      const response = await api.get(API_ENDPOINTS.TYPE_DEMANDES);
      return normalizeApiPlatformCollection(response.data);
    },
    staleTime: 1000 * 60 * 60 * 24,
    gcTime: 1000 * 60 * 60 * 24 * 7,
  });
}
